import { injectable, inject } from 'inversify-props';
import { MealCountKey, MealCountDto } from '@/models';
import { FindMealsCommand } from './commands';
import { types, IState } from '@/store';
import { Store } from 'vuex';
import { mcCounts } from '@/utils';

export interface IMealCountService {
  findMealCounts(mealCountKeys: MealCountKey[]);
  syncedMeals(): MealCountDto[];
  unsyncedMeals(): MealCountDto[];
  syncedMeal(mc: MealCountDto): boolean;
  unsyncedMeal(mc: MealCountDto): boolean;
}

@injectable()
export class MealCountService implements IMealCountService {
  @inject() private store!: Store<IState>;

  private findMealsCmd = new FindMealsCommand();
  findMealCounts(mealCountKeys: MealCountKey[]) {
    return this.findMealsCmd.run(mealCountKeys);
  }

  get syncedMeals() {
    const mealCounts = this.store.getters[types.state.mealCountDtos];
    return mealCounts.filter(this.syncedMeal);
  }

  get unsyncedMeals() {
    const mealCounts = this.store.getters[types.state.mealCountDtos];
    return mealCounts.filter(this.unsyncedMeal, this);
  }

  syncedMeal(mc: MealCountDto) {
    const countsToSyncUp = this.store.state.meals.syncUpCounts;
    const hasSyncKey = countsToSyncUp.find(k => mcCounts.matchMealCountKey(mc, k.version));
    return hasSyncKey === undefined;
  }

  unsyncedMeal(mc: MealCountDto) {
    const countsToSyncUp = this.store.state.meals.syncUpCounts;
    const hasSyncKey = countsToSyncUp.find(k => mcCounts.matchMealCountKey(mc, k.version));
    return hasSyncKey !== undefined;
  }
}
